import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getCategories } from "../../../slices/2-category/thunk";
import MediaLibraryModal from "../../0-Media/MediaLibraryModal";

// ─── Styles (inject once) ───────────────────────────────────────────────────
const css = `
 /* Breadcrumb */
  .msq-breadcrumb {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    color: #999;
    flex-wrap: wrap;
    
  }
  .msq-breadcrumb .active { color: #3DAA6E; font-weight: 600; }
  .msq-breadcrumb .change-btn {
    color: #3DAA6E;
    font-size: 10px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
  }
  .msq-breadcrumb .sep { color: #ccc; font-size: 10px; }

  /* Option cards (step 1) */
  .msq-option-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 13px 14px;
    border: 1.5px solid #E0E0E0;
    border-radius: 10px;
    margin-bottom: 10px;
    background: #fff;
    cursor: pointer;
    transition: border-color 0.15s;
  }
  .msq-option-card:last-child { margin-bottom: 0; }
  .msq-option-card:hover { border-color: #3DAA6E; }
  .msq-option-card .label { font-size: 13px; color: #222; font-weight: 500; }
  .msq-option-card .icon {
    width: 34px; height: 34px;
    border-radius: 50%;
    background: #F5F5F5;
    display: flex; align-items: center; justify-content: center;
    font-size: 18px;
  }

  /* Category grid (step 2) */
  .msq-tag-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 14px;
    font-size: 11px;
    color: #999;
  }
  .msq-tag {
    background: #F0F0F0;
    border-radius: 20px;
    padding: 3px 10px;
    font-size: 11px;
    color: #444;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .msq-tag button {
    background: none; border: none; cursor: pointer;
    color: #999; font-size: 12px; padding: 0; line-height: 1;
  }
  .msq-cat-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  .msq-cat-card {
    border: 1.5px solid #E0E0E0;
    border-radius: 10px;
    padding: 14px 10px;
    font-size: 13px;
    color: #222;
    cursor: pointer;
    text-align: center;
    background: #fff;
    transition: all 0.15s;
  }
  .msq-cat-card:hover { border-color: #3DAA6E; }
  .msq-cat-card.active {
    border-color: #3DAA6E;
    color: #3DAA6E;
    font-weight: 600;
    background: #E8F5EE;
  }

  /* Match type cards (step 3) */
  .msq-match-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 13px 14px;
    border: 1.5px solid #E0E0E0;
    border-radius: 10px;
    margin-bottom: 10px;
    background: #fff;
    cursor: pointer;
    transition: border-color 0.15s;
  }
  .msq-match-card:hover { border-color: #3DAA6E; }
  .msq-match-card .label { font-size: 13px; color: #222; font-weight: 500; }
  .msq-match-card .icon-box {
    width: 32px; height: 32px;
    border: 1.5px solid #E0E0E0;
    border-radius: 8px;
    display: flex; align-items: center; justify-content: center;
  }

  /* Form elements (steps 4-6) */
  .msq-field-label {
    font-size: 12px;
    color: #222;
    font-weight: 500;
    margin-bottom: 6px;
    display: block;
  }
  .msq-upload {
    border: 1.5px dashed #D0D0D0;
    border-radius: 10px;
    background: #F7F7F7;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 22px 16px;
    margin-bottom: 12px;
    cursor: pointer;
    gap: 6px;
  }
  .msq-upload span { font-size: 12px; color: #aaa; }
  .msq-input {
    width: 100%;
    border: 1px solid #E0E0E0;
    border-radius: 8px;
    padding: 9px 12px;
    font-size: 13px;
    color: #222;
    background: #fff;
    outline: none;
    margin-bottom: 10px;
  }
  .msq-input::placeholder { color: #bbb; }
  .msq-input:focus { border-color: #3DAA6E; }
  .msq-textarea {
    width: 100%;
    border: 1px solid #E0E0E0;
    border-radius: 8px;
    padding: 9px 12px;
    font-size: 13px;
    color: #222;
    background: #fff;
    outline: none;
    resize: none;
    min-height: 64px;
    margin-bottom: 10px;
  }
  .msq-textarea:focus { border-color: #3DAA6E; }
  .msq-radio-group { display: flex; flex-direction: column; gap: 8px; }
  .msq-radio-item {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    color: #222;
    cursor: pointer;
  }
  .msq-radio-item input[type="radio"] {
    accent-color: #3DAA6E;
    width: 16px; height: 16px;
    cursor: pointer;
  }

  /* Buttons */
  .msq-btn-save {
    background: #3DAA6E !important;
    color: #fff !important;
    border: none !important;
    border-radius: 8px !important;
    padding: 8px 20px !important;
    font-size: 13px !important;
    font-weight: 500 !important;
  }
  .msq-btn-cancel {
    background: transparent !important;
    color: #666 !important;
    border: 1px solid #E0E0E0 !important;
    border-radius: 8px !important;
    padding: 8px 16px !important;
    font-size: 13px !important;
  }
  .msq-btn-back {
    background: none !important;
    border: none !important;
    color: #999 !important;
    font-size: 13px !important;
    cursor: pointer;
    padding: 0 !important;
  }
`;

// Inject CSS once
if (typeof document !== "undefined" && !document.getElementById("msq-styles")) {
  const style = document.createElement("style");
  style.id = "msq-styles";
  style.textContent = css;
  document.head.appendChild(style);
}

// ─── SVG Icons ──────────────────────────────────────────────────────────────
const PersonIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
    <circle cx="16" cy="11" r="6" stroke="#bbb" strokeWidth="1.5" />
    <path
      d="M4 28c0-6.627 5.373-12 12-12s12 5.373 12 12"
      stroke="#bbb"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const RankedIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="1" y="8" width="3.5" height="7" rx="1" fill="#3DAA6E" />
    <rect x="6.25" y="5" width="3.5" height="10" rx="1" fill="#3DAA6E" />
    <rect x="11.5" y="1" width="3.5" height="14" rx="1" fill="#3DAA6E" />
  </svg>
);

const UnrankedIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="1" y="5" width="3.5" height="10" rx="1" fill="#ccc" />
    <rect x="6.25" y="8" width="3.5" height="7" rx="1" fill="#ccc" />
    <rect x="11.5" y="2" width="3.5" height="13" rx="1" fill="#ccc" />
  </svg>
);

// ─── Constants ───────────────────────────────────────────────────────────────
const QUESTION_TYPES = [
  { key: "star", label: "مسيرة النجم", icon: "🏆" },
  { key: "correct", label: "اختار صح", icon: "🎯" },
  { key: "whois", label: "من أنا؟", icon: "🤔" },
];

const CATEGORIES = [
  { id: 1, label: "الدوري الانجليزي" },
  { id: 2, label: "دوري أبطال أوروبا" },
  { id: 3, label: "الدوري الإسباني" },
  { id: 4, label: "الدوري الألماني" },
];

const MATCH_TYPES = [
  { key: "ranked", label: "Ranked", icon: <RankedIcon /> },
  { key: "unranked", label: "Unranked", icon: <UnrankedIcon /> },
];

// ─── Sub-step components ─────────────────────────────────────────────────────

/** Step 1: Choose question type */
const StepQuestionType = ({ onSelect }) => (
  <div>
    {QUESTION_TYPES.map((t) => (
      <div key={t.key} className="msq-option-card" onClick={() => onSelect(t)}>
        <span className="label">{t.label}</span>
        <span className="icon">{t.icon}</span>
      </div>
    ))}
  </div>
);

/** Step 2: Choose category */
const StepCategory = ({
  questionType,
  selectedCat,
  onSelect,
  onChangeType,
  categories,
  loading,
}) => (
  <div>
    <div className="msq-tag-row">
      <span>{questionType?.label}</span>
      <span className="msq-breadcrumb sep">›</span>
      <span className="msq-tag">
        تغيير
        <button onClick={onChangeType}>✕</button>
      </span>
    </div>

    {loading ? (
      <p>Loading...</p>
    ) : (
      <div className="msq-cat-grid">
        {categories?.map((c) => (
          <div
            key={c.id}
            className={`msq-cat-card${
              selectedCat?.id === c._id ? " active" : ""
            }`}
            onClick={() => onSelect(c)}
          >
            {c.name || c.label}
          </div>
        ))}
      </div>
    )}
  </div>
);

/** Step 3: Choose match type */
const StepMatchType = ({
  questionType,
  category,
  selected,
  onToggle,
  onNext,
  onBack,
}) => {
  return (
    <div>
      <div className="msq-breadcrumb" style={{ marginBottom: "14px" }}>
        <span className="active">{questionType?.label}</span>
        <span className="sep">›</span>
        <span>{category?.name}</span>
      </div>

      {MATCH_TYPES.map((m) => {
        const isActive = selected.includes(m.key);

        return (
          <div
            key={m.key}
            className="msq-match-card"
            onClick={() => onToggle(m.key)}
            style={{
              borderColor: isActive ? "#3DAA6E" : "#E0E0E0",
              background: isActive ? "#E8F5EE" : "#fff",
            }}
          >
            <span className="label">{m.label}</span>

            <span
              className="icon-box"
              style={{
                borderColor: isActive ? "#3DAA6E" : "#E0E0E0",
              }}
            >
              {m.icon}
            </span>
          </div>
        );
      })}

      {/* buttons */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 15,
        }}
      >
        <button className="msq-btn-back" onClick={onBack}>
          رجوع
        </button>

        <button
          className="msq-btn-save"
          onClick={onNext}
          disabled={!selected.length}
          style={{
            opacity: !selected.length ? 0.5 : 1,
            cursor: !selected.length ? "not-allowed" : "pointer",
          }}
        >
          التالي
        </button>
      </div>
    </div>
  );
};

/** Step 4a*/
const FormStar = ({
  questionType,
  category,
  form,
  onChange,
  openMediaModal,
}) => (
  <div>
    <label className="msq-field-label">صورة اللاعب</label>
    <div className="msq-upload" onClick={openMediaModal}>
      {form.image ? (
        <img
          src={form.image}
          alt="preview"
          style={{ width: "100%", borderRadius: 8 }}
        />
      ) : (
        <>
          <PersonIcon />
          <span>اضغط لرفع صورة</span>
        </>
      )}
    </div>
    <label className="msq-field-label">السؤال</label>
    <input
      className="msq-input"
      placeholder="اكتب السؤال..."
      value={form.questionText || ""}
      onChange={(e) => onChange("questionText", e.target.value)}
    />
    <label className="msq-field-label">اسم اللاعب الصحيح</label>
    <input
      className="msq-input"
      placeholder="اكتب اسم اللاعب..."
      value={form.playerName || ""}
      onChange={(e) => onChange("playerName", e.target.value)}
    />
  </div>
);

/** Step 4b*/
const FormWhoIs = ({
  questionType,
  category,
  form,
  onChange,
  openMediaModal,
}) => (
  <div>
    <div className="msq-breadcrumb">
      <span>{questionType?.label}</span>
      <span className="sep">›</span>
      <span>{category?.label}</span>
      <span className="sep">›</span>
      <button className="change-btn">تغيير</button>
    </div>
    <label className="msq-field-label">صورة اللاعب</label>
    <div className="msq-upload" onClick={openMediaModal}>
      {form.image ? (
        <img
          src={form.image}
          alt="preview"
          style={{ width: "100%", borderRadius: 8 }}
        />
      ) : (
        <>
          <PersonIcon />
          <span>اضغط لرفع صورة</span>
        </>
      )}
    </div>
    <label className="msq-field-label">السؤال</label>
    <input
      className="msq-input"
      placeholder="اكتب السؤال..."
      value={form.questionText || ""}
      onChange={(e) => onChange("questionText", e.target.value)}
    />
    <label className="msq-field-label">اسم اللاعب الصحيح</label>
    <input
      className="msq-input"
      placeholder="اكتب اسم اللاعب..."
      value={form.playerName || ""}
      onChange={(e) => onChange("playerName", e.target.value)}
    />
  </div>
);

/** Step 4c */
const FormCorrect = ({
  questionType,
  category,
  form,
  onChange,
  openMediaModal,
}) => (
  <div>
    <label className="msq-field-label">صورة</label>
    <div className="msq-upload" onClick={() => openMediaModal(true)}>
      {form.image ? (
        <img
          src={form.image}
          alt="preview"
          style={{ width: "100%", borderRadius: 8 }}
        />
      ) : (
        <>
          <PersonIcon />
          <span>اضغط لرفع صورة</span>
        </>
      )}
    </div>

    <label className="msq-field-label">نص السؤال</label>
    <textarea
      className="msq-textarea"
      placeholder="اكتب السؤال هنا..."
      value={form.questionText || ""}
      onChange={(e) => onChange("questionText", e.target.value)}
    />

    <label className="msq-field-label">الاختيارات</label>

    <div className="msq-radio-group">
      {[1, 2, 3, 4].map((n) => (
        <div key={n} className="msq-radio-item">
          {/* radio button */}
          <input
            type="radio"
            name="correctOption"
            checked={form.selectedOption === n}
            onChange={() => onChange("selectedOption", n)}
          />

          {/* input text */}
          <input
            className="msq-input"
            placeholder={`الاختيار ${n}`}
            value={form[`option${n}`] || ""}
            onChange={(e) => onChange(`option${n}`, e.target.value)}
          />
        </div>
      ))}
    </div>
  </div>
);

// ─── Main Component ──────────────────────────────────────────────────────────
const MultiStepQuestionModal = ({
  isOpen,
  toggle,
  onSubmit,
  initialData,
  isEdit,
}) => {
  const [step, setStep] = useState(0);
  const [questionType, setQuestionType] = useState(null);
  const [category, setCategory] = useState(null);
  const [matchType, setMatchType] = useState([]);
  const [form, setForm] = useState({});
  const [history, setHistory] = useState([]);
  const [mediaModal, setMediaModal] = useState(false);

  const dispatch = useDispatch();

  const { categories, loading, error } = useSelector(
    (state) => state.Categories,
  );

  useEffect(() => {
    // console.log("Initial Data:", initialData);
    if (initialData && isEdit) {
      let qType = null;

      if (initialData.type === "mcq") {
        qType = { key: "correct", label: "اختار صح" };
      }

      if (initialData.type === "player") {
        qType = { key: "whois", label: "من أنا؟" };
      }

      if (initialData.type === "career") {
        qType = { key: "star", label: "مسيرة النجم" };
      }

      setQuestionType(qType);

      // category
      setCategory(initialData.category);

      // match type
      const matches = [];

      if (initialData.isRanked) matches.push("ranked");
      if (initialData.isUnRanked) matches.push("unranked");

      setMatchType(matches);

      // form data
      const formData = {
        image: initialData.image || "",
        questionText: initialData.question || "",
        playerName: initialData.answer || "",
      };

      // mcq options
      if (initialData.type === "mcq") {
        initialData.options?.forEach((opt, index) => {
          formData[`option${index + 1}`] = opt.text;

          if (opt.isCorrect) {
            formData.selectedOption = index + 1;
          }
        });
      }

      setForm(formData);

      setStep(2);
    }
  }, [initialData, isEdit]);

  useEffect(() => {
    if (isOpen) {
      dispatch(getCategories({ page: 1, limit: 100 }));
    }
  }, [isOpen, dispatch]);

  const resetAll = () => {
    setStep(0);
    setQuestionType(null);
    setCategory(null);
    setMatchType([]);
    setForm({});
  };

  const handleClose = () => {
    resetAll();
    toggle();
  };

  const handleFormChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = () => {
    // if (!category) return alert("اختار التصنيف");
    if (!matchType.length) return alert("اختار نوع المسابقة");
    if (questionType?.key === "correct" && !form.selectedOption) {
      return alert("اختار الإجابة الصحيحة");
    }

    const base = {
      categoryId: category?._id,
      isRanked: matchType.includes("ranked"),
      isUnRanked: matchType.includes("unranked"),
      image: form.image || "",
    };

    let payload = {};

    // MCQ
    if (questionType?.key === "correct") {
      payload = {
        ...base,
        type: "mcq",
        question: form.questionText,
        options: [
          { text: form.option1 || "", isCorrect: form.selectedOption === 1 },
          { text: form.option2 || "", isCorrect: form.selectedOption === 2 },
          { text: form.option3 || "", isCorrect: form.selectedOption === 3 },
          { text: form.option4 || "", isCorrect: form.selectedOption === 4 },
        ].filter((o) => o.text),
      };
    }

    // Player
    if (questionType?.key === "whois") {
      payload = {
        ...base,
        type: "player",
        question: form.questionText,
        answer: form.playerName,
      };
    }

    // Career
    if (questionType?.key === "star") {
      payload = {
        ...base,
        type: "career",
        question: form.questionText,
        answer: form.playerName,
      };
    }

    // console.log("FORM:", form);
    // console.log("TYPE:", questionType);
    // console.log("CATEGORY:", category);
    // console.log("MATCH TYPE:", matchType);
    // console.log("FINAL PAYLOAD:", payload);

    onSubmit?.(payload);
    handleClose();
  };

  // Step titles
  const titles = [
    "اختر نوع السؤال",
    "اختار التصنيف",
    "اختر نوع المسابقة",
    isEdit
      ? "تعديل السؤال"
      : questionType?.key === "star"
        ? "إضافة سؤال - مسيرة النجم"
        : questionType?.key === "whois"
          ? "إضافة سؤال - من أنا؟"
          : "إضافة سؤال - اختار صح",
  ];

  const goBack = () => {
    setHistory((prev) => {
      const newHistory = [...prev];
      const prevStep = newHistory.pop();

      if (prevStep !== undefined) {
        setStep(prevStep);
      }

      return newHistory;
    });
  };
  // Render current step body
  const renderBody = () => {
    switch (step) {
      case 0:
        return (
          <StepQuestionType
            onSelect={(t) => {
              setQuestionType(t);
              setHistory((prev) => [...prev, step]);
              setStep(1);
            }}
          />
        );
      // case 1:
      //   return (
      //     <StepCategory
      //       questionType={questionType}
      //       selectedCat={category}
      //       categories={categories}
      //       loading={loading}
      //       onSelect={(c) => {
      //         setCategory(c);
      //         setStep(2);
      //       }}
      //       onChangeType={() => {
      //         setQuestionType(null);
      //         setStep(0);
      //       }}
      //     />
      //   );
      case 1:
        return (
          <StepMatchType
            questionType={questionType}
            category={category}
            selected={matchType}
            onToggle={(key) => {
              setMatchType((prev) =>
                prev.includes(key)
                  ? prev.filter((x) => x !== key)
                  : [...prev, key],
              );
            }}
            onNext={() => {
              if (!matchType.length) {
                alert("لازم تختار نوع مسابقة واحد على الأقل");
                return;
              }
              setStep(2);
            }}
            onBack={() => setStep(0)}
          />
        );
      case 2:
        if (questionType?.key === "star")
          return (
            <FormStar
              questionType={questionType}
              category={category}
              form={form}
              onChange={handleFormChange}
              openMediaModal={() => setMediaModal(true)}
            />
          );
        if (questionType?.key === "whois")
          return (
            <FormWhoIs
              questionType={questionType}
              category={category}
              form={form}
              onChange={handleFormChange}
              openMediaModal={() => setMediaModal(true)}
            />
          );
        return (
          <FormCorrect
            questionType={questionType}
            category={category}
            form={form}
            onChange={handleFormChange}
            openMediaModal={() => setMediaModal(true)}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={handleClose}
      centered
      size="md"
      className="msq-modal"
    >
      <ModalHeader toggle={handleClose}>{titles[step]}</ModalHeader>

      <ModalBody>{renderBody()}</ModalBody>

      {step === 2 && (
        <ModalFooter>
          <div style={{ display: "flex", gap: 8 }}>
            <Button
              className="msq-btn-back"
              onClick={() => setStep((s) => s - 1)}
            >
              رجوع
            </Button>
            <Button className="msq-btn-cancel" onClick={handleClose}>
              إلغاء
            </Button>
          </div>
          <Button className="msq-btn-save" onClick={handleSubmit}>
            حفظ السؤال
          </Button>
        </ModalFooter>
      )}

      <MediaLibraryModal
        isOpen={mediaModal}
        onClose={() => setMediaModal(false)}
        onSelect={(url) => {
          handleFormChange("image", url);
          setMediaModal(false);
        }}
        multi={false}
        showTabs={{ images: true }}
      />
    </Modal>
  );
};

export default MultiStepQuestionModal;
